<div class="sp-p-16">
  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Card Example:</h4>
    <div ui-row>
      <div ui-col uiXs="8">
        <ui-card style="width: 300px" [uiBordered]="true" uiTitle="Card title" [uiExtra]="extraTemplate">
          <p>Card content</p>
          <p>Card content</p>
          <p>Card content</p>
        </ui-card>

        <ng-template #extraTemplate>
          <a>More</a>
        </ng-template>
      </div>
      <div ui-col uiXs="8">
        <ui-card uiHoverable style="width: 240px" [uiCover]="coverTemplate">
          <ui-card-meta uiTitle="Europe Street beat" uiDescription="www.instagram.com"></ui-card-meta>
        </ui-card>
        <ng-template #coverTemplate>
          <img alt="example" src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png" />
        </ng-template>
      </div>
      <div ui-col uiXs="8">
        <ui-toggle [(ngModel)]="loading"></ui-toggle>
        <ui-card style="width: 300px; margin-top: 16px" [uiLoading]="loading">
          <ui-card-meta [uiAvatar]="avatarTemplate" uiTitle="Card title" uiDescription="This is the description"></ui-card-meta>
        </ui-card>
        <ui-card style="width: 300px; margin-top: 16px" [uiActions]="[actionSetting, actionEdit, actionEllipsis]">
          <ui-skeleton [uiActive]="true" [uiLoading]="loading" [uiAvatar]="{ size: 'large' }">
            <ui-card-meta [uiAvatar]="avatarTemplate" uiTitle="Card title" uiDescription="This is the description"></ui-card-meta>
          </ui-skeleton>
        </ui-card>
        <ng-template #avatarTemplate>
          <ui-avatar uiSrc="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"></ui-avatar>
        </ng-template>
        <ng-template #actionSetting>
          <ui-icon uiType="outline:setting"></ui-icon>
        </ng-template>
        <ng-template #actionEdit>
          <ui-icon uiType="outline:edit"></ui-icon>
        </ng-template>
        <ng-template #actionEllipsis>
          <ui-icon uiType="outline:ellipsis"></ui-icon>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Card Example in Rows:</h4>

    <div style="background: #ececec; padding: 30px">
      <div ui-row [uiGutter]="8">
        <div ui-col [uiXs]="8">
          <ui-card uiTitle="Card title">
            <p>Card content</p>
          </ui-card>
        </div>
        <div ui-col [uiXs]="8">
          <ui-card uiTitle="Card title">
            <p>Card content</p>
          </ui-card>
        </div>
        <div ui-col [uiXs]="8">
          <ui-card uiTitle="Card title">
            <p>Card content</p>
          </ui-card>
        </div>
      </div>
    </div>
  </div>
</div>
